(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.cart-left-column');
    if (!root) return;

    root.querySelectorAll('.slick-slider-class .carousel').forEach(function (row) {
      if (row.dataset.fbCartUpsells) return;
      row.dataset.fbCartUpsells = 'true';

      function unavailable(card) {
        return card.classList.contains('not-clickable') || card.classList.contains('not-available');
      }

      row.querySelectorAll('.product-card-upsell-slider').forEach(function (card) {
        var add = card.querySelector('.upsell-add-btn');
        if (add) add.remove();
        card.setAttribute('role', 'button');
        card.addEventListener('keydown', function (event) {
          if (event.target !== card || (event.key !== 'Enter' && event.key !== ' ')) return;
          event.preventDefault();
          if (!unavailable(card)) card.click();
        });

        card.querySelectorAll('.product-image-wrapper-upsell-slider img').forEach(function (img) {
          var url = new URL(img.getAttribute('src'), window.location.origin);
          url.searchParams.set('width', '450');
          url.searchParams.set('height', '600');
          img.src = url.href;
          img.width = 450;
          img.height = 600;
        });

        var price = card.querySelector('.slide-price-upsell-slider');
        if (price && !/^\+/.test(price.textContent.trim())) price.textContent = '+ ' + price.textContent.trim();
      });

      function syncAvailability() {
        var availableCount = 0;
        Array.prototype.forEach.call(row.children, function (slide) {
          var card = slide.querySelector('.product-card-upsell-slider');
          if (!card) return;
          var hidden = unavailable(card);
          slide.hidden = hidden;
          card.tabIndex = hidden ? -1 : 0;
          card.setAttribute('aria-pressed', String(card.classList.contains('selected')));
          if (!hidden) availableCount++;
        });
        row.closest('.slick-slider-class').classList.toggle('fb-cart-upsell-empty', availableCount === 0);
        row.dispatchEvent(new Event('fb:scroll-row-updated'));
      }

      new MutationObserver(syncAvailability).observe(row, { subtree: true, attributes: true, attributeFilter: ['class'] });
      syncAvailability();
    });

    root.querySelectorAll('.fb-cart-upsell-arrow').forEach(function (arrow) {
      arrow.type = 'button';
      arrow.setAttribute('aria-label', arrow.classList.contains('fb-cart-upsell-arrow--prev') ? root.dataset.upsellPrevious : root.dataset.upsellNext);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
